import React, { useEffect, useRef } from "react";
import EventoCard from "../../../../components/evento-card";
import AnexoCard from "../../../../components/anexo/AnexoCard";
import EventoVisualizarController from "../controller/evento-visualizar.controller";
import { Card } from "primereact/card";
import If from "../../../../../vendors/components/If";
import EventoVisualizarHeader from "../components/EventoVisualizarHeader";
import Contribuir from "../components/Contribuir";
import NormaDefinitiva from "../components/NormaDefinitiva";
import Degravacao from "../components/Degravacao";
import SessaoPresencial from "../components/SessaoPresencial";
import ContribuicaoPublicada from "../components/ContribuicaoPublicada";
import Tabs from "../../../../components/tabs";
import DocumentosdoEvento from "../components/DocumentosdoEvento";
import EventoInformesPopup from "../../../../components/evento-informes-popup";

export default function EventoVisualizar() {
  const controller = new EventoVisualizarController(false);
  const evento = controller.evento;
  const tpReuniao = controller.tpReuniao;

  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    controller.init();
  }, []);

  const codPropostaNorma = evento.codPropostaNorma

  return (
    <>
      <EventoInformesPopup evento={evento} />
      <div
        className="evento-vis-wrapper"
        style={{ flexDirection: controller.isCardExpanded ? 'column' : undefined }}
      >
        <If condition={controller.show && !controller.isCardExpanded}>
          <div className="evento-vis-col-secundaria">
            <EventoCard
              evento={evento}
              onHide={() => controller.handleShow()}
              usuarioLogado={controller.isAuthenticated()}
              tpReuniao={tpReuniao}
              isExpanded={controller.isCardExpanded}
              onExpandToggle={() => controller.toggleCardExpanded()}
            />
            <AnexoCard
              showDownload={true}
              handleDownload={(e: any) => {
                controller.downloadPropostaNorma(e);
              }}
              handleAllDownload={() => {
                controller.downloadTodosAnexos();
              }}
              lista={controller.lista}
              handleTabDocumentacao={(value: any) => {
                controller.handleTab(value);
                handleScrollToTop();
              }}
            />
          </div>
        </If>

        {/* Caso o card esteja expandido, ele ocupa toda a parte superior */}
        <If condition={controller.isCardExpanded}>
          <div className="w-full mb-3">
            <EventoCard
              evento={evento}
              onHide={() => controller.handleShow()}
              usuarioLogado={controller.isAuthenticated()}
              tpReuniao={tpReuniao}
              isExpanded={controller.isCardExpanded}
              onExpandToggle={() => controller.toggleCardExpanded()}
            />
          </div>
        </If>

        <div
          className="evento-vis-col-primaria"
          style={{ width: (controller.show && !controller.isCardExpanded) ? "" : "100%" }}
        >
          <If condition={controller.isCardExpanded}>
            <div className="mb-4">
              <AnexoCard
                showDownload={true}
                handleDownload={(e: any) => {
                  controller.downloadPropostaNorma(e);
                }}
                handleAllDownload={() => {
                  controller.downloadTodosAnexos();
                }}
                lista={controller.lista}
                handleTabDocumentacao={(value: any) => {
                  controller.handleTab(value);
                  handleScrollToTop();
                }}
              />
            </div>
          </If>
          <Card
            className="card-no-spaces"
            style={{ marginTop: controller.isCardExpanded ? '0px' : '' }}
            header={() => (
              <EventoVisualizarHeader controller={controller} evento={evento} />
            )}
          >
            <If condition={controller.abaList.length > 0}>
              <Tabs
                onClick={(value: any) => controller.handleTab(value)}
                ativo={controller.tab}
                items={controller.abaList}
              />
            </If>
            <Contribuir controller={controller} isBlock={false} />

            <SessaoPresencial controller={controller} />

            <NormaDefinitiva
              controller={controller}
              normaDefinitiva={controller.evento.dsLinkNormaDefinitiva}
            />
            <Degravacao controller={controller} />
            <ContribuicaoPublicada
              rollBackUrl={`/evento/visualizar?tab=${controller.tab}`}
              controller={controller}
            />
            {codPropostaNorma && (
              <DocumentosdoEvento
                controller={controller}
                codPropostaNorma={codPropostaNorma}
              />
            )}
          </Card>
        </div>
      </div>
    </>
  );
}
